import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';

export type AzureSubscription = {
  id: string;
  name: string;
};

export interface BeehiveAzureSubscriptionsApi {
  listSubscriptions(): Promise<AzureSubscription[]>;
}

export const beehiveAzureSubscriptionsApiRef =
  createApiRef<BeehiveAzureSubscriptionsApi>({
    id: 'plugin.beehive-scaffolder.azure-subscriptions',
  });

export class BeehiveAzureSubscriptionsClient
  implements BeehiveAzureSubscriptionsApi
{
  constructor(
    private readonly options: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
    },
  ) {}

  async listSubscriptions(): Promise<AzureSubscription[]> {
    const baseUrl = await this.options.discoveryApi.getBaseUrl(
      'beehive-scaffolder',
    );
    const response = await this.options.fetchApi.fetch(
      `${baseUrl}/subscriptions`,
    );

    if (!response.ok) {
      throw new Error(
        `Failed to load Azure subscriptions: ${response.status} ${response.statusText}`,
      );
    }

    const data: unknown = await response.json();

    if (!Array.isArray(data)) {
      throw new Error('Azure subscriptions response must be an array');
    }

    return data.map((item, index) => {
      if (
        typeof item !== 'object' ||
        item === null ||
        typeof (item as AzureSubscription).id !== 'string' ||
        typeof (item as AzureSubscription).name !== 'string'
      ) {
        throw new Error(
          `Azure subscriptions response item ${index} must contain string id and name`,
        );
      }

      return {
        id: (item as AzureSubscription).id,
        name: (item as AzureSubscription).name,
      };
    });
  }
}
